import React, { useState, useContext, useEffect, useLayoutEffect } from "react";
import { Pagination, Dropdown, DropdownButton, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import DatePicker from "react-datepicker";
import moment from "moment";

import { Button, Form, Modal, Row, Col } from "react-bootstrap";

import { DevContext } from "../context";
import { VaccineDto, PopulationTypeDto, municipalities, ProviderSearchParamsDto } from "../../models";
import API from '../../lib/devApi';
import { useIsMobile } from '../hooks';

import "react-datepicker/dist/react-datepicker.css";

export default function FilterHeader(props: any) {

    const { providers, providerSearchParams, setProviderSearchParams, showLoading, setShowLoading } = useContext(DevContext);
    const isMobile = useIsMobile();

    const [showFilterModal, setShowFilterModal] = useState(false);
    const [pageSizeOptions, setPageSizeOptions] = useState([{count: 5, desc: "5 / página"}, {count: 10, desc: "10 / página"}, {count: 25, desc: "25 / página"}]);
    const [currentPageSizeOption, setCurrentPageSizeOption] = useState({count: 5, desc: "5 / página"});
    const [currentPageSize, setCurrentPageSize] = useState(providerSearchParams && providerSearchParams.pageSize? providerSearchParams.pageSize : 5);
    const [currentPageNumber, setCurrentPageNumber] = useState(providerSearchParams && providerSearchParams.pageNumber? providerSearchParams.pageNumber : 0);
    const [totalPages, setTotalPages] = useState(0);

    const [isInvalidName, setIsInvalidName] = useState(false);

    // To show the actual dropdowns on the screen.
    const [vaccineDropdowns, setVaccineDropdowns] = useState<number[]>([]);
    const [populationDropdowns, setPopulationDropdowns] = useState<number[]>([]);
    // Data of the filters.
    const [filterByVaccines, setFilterByVaccines] = useState<string[]>();
    const [filterByPopulations, setFilterByPopulations] = useState<string[]>();
    const [filterByMunicipality, setFilterByMunicipality] = useState<number>();
    const [filterByName, setFilterByName] = useState<string>("");
    // const [filterByStartDate, setFilterByStartDate] = useState<Date|null>();
    // const [filterByEndDate, setFilterByEndDate] = useState<Date|null>();
    // Data for the dropdowns.
    const [vaccines, setVaccines] = useState<VaccineDto[]>([]);
    const [populationTypes, setPopulationTypes] = useState<PopulationTypeDto[]>([]);

    useLayoutEffect(() => {
        if(showFilterModal) {
            (async () => {
                const vax = await API.GetAllVaccines();
                const pops = await API.GetAllPopulationTypes();
                setVaccines(vax);
                setPopulationTypes(pops);
            })();
        }
    }, [showFilterModal]);

    const clearFilters = () => {
        setVaccineDropdowns([]);
        setFilterByVaccines([]);
        setFilterByPopulations([]);
        setFilterByName("");
        setFilterByMunicipality(undefined);
        // setFilterByStartDate(null);
        // setFilterByEndDate(null);

        let params = {
            name: "",
            municipalityId: null,
            startTime: null,
            endTime: null,
            pageNumber: 0,
            pageSize: 0
        };
        setProviderSearchParams(params);
    }

    useEffect(() => {
        if(providers) {
            let pages = Math.floor(providers.total / providers.pageSize);
            setTotalPages(pages);
        }

    }, [providers]);

    useEffect(() => {
        const foundIndex = pageSizeOptions.findIndex((value) => {
            return value.count == currentPageSize;
        });

        if(foundIndex > -1) {
            setCurrentPageSizeOption(pageSizeOptions[foundIndex]);
        }
    }, [currentPageSize]);

    // restore and show filter on modal window open.
    useEffect(() => {

        if(showFilterModal) {
            // console.log(providerSearchParams);
            if(providerSearchParams && providerSearchParams.name) {
                setFilterByName(providerSearchParams.name);
            }   

            if(providerSearchParams && providerSearchParams.municipalityId) {
                setFilterByMunicipality(providerSearchParams.municipalityId);
            }

            // restore vaccines
            if(providerSearchParams && providerSearchParams.vaccines && providerSearchParams.vaccines.length > 0) {
                let vaccineDdl: number[] = [];
                let vaccineIds: string[] = [];
                providerSearchParams.vaccines.forEach((vaccine, idx) => {
                    vaccineDdl.push(idx);
                    vaccineIds.push(vaccine);
                });

                setVaccineDropdowns(vaccineDdl);
                setFilterByVaccines(vaccineIds);
            }

            // restore populatiosdn
            if(providerSearchParams && providerSearchParams.populations) {

                let popDdl: number[] = [];
                let popIds: string[] = [];
                providerSearchParams.populations.forEach((pop, idx) => {
                    popDdl.push(idx);
                    popIds.push(pop);
                });

                setPopulationDropdowns(popDdl);
                setFilterByPopulations(popIds);
            }

            // if(providerSearchParams && providerSearchParams.startTime) {
            //     setFilterByStartDate(moment(providerSearchParams.startTime).toDate());
            // }

            // if(providerSearchParams && providerSearchParams.endTime) {
            //     setFilterByEndDate(providerSearchParams.endTime);
            // }

        }

    }, [showFilterModal]);

    const renderPagination = () => {
        let result = [];
        if(providers) {

            let startIndex: number = 0;

            if(currentPageNumber > 5) {
                for(let i=currentPageNumber; i > 0; i--) {
                    // find the last index that's a divisor of 6
                    // and print the page numbers using that as an anchor
                    if(i % 2 == 0 && i % 3 == 0) {
                        startIndex = i;
                        break;
                    }
                }
            }

            let endIndex: number = startIndex + 6;


            for(let i=startIndex; i < totalPages && i < endIndex; i++) {
                if(i == providers.pageNumber) {
                    result.push(
                        <Pagination.Item active key={i} onClick={() => renderPageOfData(i)}>
                        {i + 1}
                        </Pagination.Item>
                    )
                }
                else {
                    result.push(
                        <Pagination.Item key={i} onClick={() => renderPageOfData(i)}>
                        {i + 1}
                        </Pagination.Item>
                    )
                }
            }

        }

        return result;
    }

    const renderPageOfData = (nextPage: number, pageSize: number = currentPageSize) => {
        try {
            const params = {...providerSearchParams};
            params.pageNumber = nextPage;
            params.pageSize = pageSize;
            setShowLoading(true);
            setCurrentPageNumber(nextPage);
            setProviderSearchParams(params);
        } catch (error) {
            console.log(error);
        }
        finally {
            setShowLoading(false);
        }
    }

    const filterFormSubmit = async (event: any) => {
        event.preventDefault();
        event.stopPropagation();

        if(isInvalidName) {
            return;
        }
        
        setShowLoading(true);

        try {

            let params: ProviderSearchParamsDto = {
                name: filterByName,
                pageNumber: 0,
                pageSize: isMobile? 0 : 5
            }

            // if(filterByStartDate) {
            //     const _sd = new Date(2023, 0, 1, filterByStartDate.getHours(), filterByStartDate.getMinutes());
            //     params = Object.assign({}, params, { startTime: _sd });
            // }

            // if(filterByEndDate) {
            //     const _ed = new Date(2023, 0, 1, filterByEndDate.getHours(), filterByEndDate.getMinutes());
            //     params = Object.assign({}, params, { endTime: _ed });
            // }

            if(filterByMunicipality) {
                params = Object.assign({}, params, { municipalityId: filterByMunicipality })
            }

            if(filterByVaccines) {
                params = Object.assign({}, params, { vaccines: filterByVaccines });
            }

            if(filterByPopulations) {
                params = Object.assign({}, params, { populations: filterByPopulations });
            }

            setProviderSearchParams(params);

        } catch (error) {
            console.log(error);
        }
        finally {
            setShowLoading(false);
        }
    }

    const hasFilters = () => {
        const result: boolean = (filterByVaccines && filterByVaccines.length > 0) || (filterByPopulations && filterByPopulations.length > 0) || (filterByMunicipality != null && filterByMunicipality != undefined)
        || (filterByName != null && filterByName != undefined && filterByName != "")
        // || (filterByStartDate != null && filterByStartDate != undefined) || (filterByEndDate != null && filterByEndDate != undefined);
        return result;
    }

    return (
        <React.Fragment>
            <div className='mobile-input-container'>
                <div>
                    <Button onClick={() => setShowFilterModal(true)} variant="see-more" style={{fontSize: 18}}><FontAwesomeIcon icon={faFilter} fontSize={18} />&nbsp;Filtrar Proveedores</Button>
                </div>
            </div>
            
            <div className="list-header-container">
                <div>
                    <div>
                        <Button onClick={() => setShowFilterModal(true)} variant="see-more" style={{fontSize: 18}}><FontAwesomeIcon icon={faFilter} fontSize={18} />&nbsp;Filtrar Proveedores</Button>
                    </div>
                </div>
                <div className="list-pagination-container">
                    {
                        providers && providers.pageSize > 0?
                        <>
                            <div>
                                <Pagination>
                                    {
                                        currentPageNumber > 5?
                                        <>
                                            <Pagination.First onClick={() => renderPageOfData(0)} />
                                        </>
                                        : <></>
                                    }
                                    {
                                        currentPageNumber > 0?
                                            <Pagination.Prev onClick={() => renderPageOfData(currentPageNumber - 1)} />
                                            : <></>
                                    }
                                    {
                                        currentPageNumber > 5?
                                            <>
                                            <Pagination.Item onClick={() => renderPageOfData(0)}>{1}</Pagination.Item>
                                            <Pagination.Ellipsis />
                                            </>
                                            : <></>
                                    }
                                    {
                                        renderPagination()
                                    }
                                    {
                                        providers.total > 6 && (currentPageNumber < (totalPages - 1) && totalPages > 5)?
                                        <>
                                            <Pagination.Ellipsis />
                                            <Pagination.Item onClick={() => renderPageOfData(totalPages)}>
                                                {totalPages}
                                            </Pagination.Item>
                                        </>
                                        : <></>
                                    }
                                    {
                                        currentPageNumber < (totalPages - 1) && totalPages > 5?
                                            <>  
                                                <Pagination.Next onClick={() => renderPageOfData(currentPageNumber + 1)} />
                                                <Pagination.Last onClick={() => renderPageOfData(totalPages)}/>
                                            </>
                                        : <></>
                                    }
                                </Pagination>
                            </div>
                            <div>
                                <DropdownButton variant="secondary" id="dropdown-basic-button" title={currentPageSizeOption.desc}>
                                    {pageSizeOptions.map((opt, idx) => {
                                        return <Dropdown.Item key={idx} onClick={() => {
                                            setCurrentPageSize(opt.count);
                                            renderPageOfData(0, opt.count);
                                        }} active={currentPageSize == opt.count}>{opt.desc}</Dropdown.Item>
                                    })}
                                </DropdownButton>
                            </div>
                        </>
                        : <></>
                    }
                </div>
            </div>

            <Modal show={showFilterModal} onHide={() => {
                setShowFilterModal(false);
                setVaccineDropdowns([]);
                setFilterByVaccines([]);
                setFilterByName("");
                setFilterByMunicipality(undefined);
            }}>
                <Modal.Header closeButton>
                    <h2>Filtrar Proveedores</h2>
                </Modal.Header>
                <Modal.Body>
                    {
                        hasFilters()?
                        <>
                            <div style={{display: "flex", flexDirection: "row", alignItems: "flex-end", justifyContent: "flex-end"}}>
                                <div onClick={() => clearFilters()} className="list-filter-btn">
                                    <span style={{userSelect: "none"}}><FontAwesomeIcon icon={faFilterCircleXmark} fontSize={24} />&nbsp;Remover Filtros</span>
                                </div>
                            </div>
                            <br />
                        </>: <></>
                    }
                    <Form noValidate onSubmit={(event) => filterFormSubmit(event)}>
                        <fieldset>
                            <Row>
                                <Col lg={3}>
                                    <Form.Label>N&oacute;mbre</Form.Label>
                                </Col>
                                <Col lg={9}>
                                    <Form.Control isInvalid={isInvalidName} value={filterByName} onChange={(e) => {
                                        const pattern = new RegExp("^[a-zA-Z0-9\.\\s\,]*\-{0,1}$");
                                        setIsInvalidName(!pattern.test(e.target.value));
                                        setFilterByName(e.target.value);
                                    }} type="text" />
                                    <Form.Control.Feedback type="invalid">El n&oacute;mbre contiene caracteres invalidos. Characteres validos son '-', '.' y ','.</Form.Control.Feedback>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col lg={3}>
                                    <Form.Label>Municipio</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Select value={filterByMunicipality? filterByMunicipality : ""} onChange={(e) => setFilterByMunicipality(parseInt(e.target.value, 10))} aria-label="Seleccione el municipio">
                                        <option>Seleccione el municipio</option>
                                        {
                                            municipalities.map((municipality: any, index: number) => {
                                                return <option key={`mun-${index}`} value={municipality.municipalityId}>{municipality.name}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col>
                                    <Button variant="link" onClick={() => {
                                        let vxDdl = [...vaccineDropdowns];
                                        vxDdl.push(1);
                                        setVaccineDropdowns(vxDdl);
                                    }}>Añadir tipo de vacuna</Button>
                                </Col>
                            </Row>
                            <br />
                            {
                                vaccineDropdowns.map((_, idx) => {
                                    return (
                                        <Row key={`vaxDdl-${idx}`}>
                                            <Col lg={8}>
                                                <Form.Select onChange={(e) => {

                                                    let filtered = filterByVaccines? [...filterByVaccines] : [];
                                                    if(filtered[idx]) {
                                                        filtered[idx] = e.target.value;
                                                    }
                                                    else {
                                                        filtered.push(e.target.value);
                                                    }
                                                    setFilterByVaccines(filtered);

                                                }} value={ filterByVaccines && filterByVaccines[idx]? filterByVaccines[idx] : "" } aria-label="Seleccione el tipo de vacuna">
                                                    <option>Seleccione el tipo de vacuna</option>
                                                    {
                                                        vaccines.map((vaccine, index) => {
                                                            return <option value={vaccine.vaccineId} key={`vax-${idx}-${index}`}>{vaccine.name}</option>
                                                        })
                                                    }
                                                </Form.Select>
                                            </Col>
                                            <Col lg={2}>
                                                <Button onClick={() => {
                                                    let vxDdl = [...vaccineDropdowns];
                                                    let filtered = filterByVaccines? [...filterByVaccines] : [];
                                                    vxDdl.splice(idx, 1);
                                                    filtered.splice(idx, 1);
                                                    setVaccineDropdowns(vxDdl);
                                                    setFilterByVaccines(filtered);
                                                }} variant="link">Remover</Button>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                            <br />
                            <Row>
                                <Col>
                                    <Button onClick={() => {
                                        let popDdl = [...populationDropdowns];
                                        popDdl.push(1);
                                        setPopulationDropdowns(popDdl);
                                    }} variant="link">Añadir tipo de población</Button>
                                </Col>
                            </Row>
                            {
                                populationDropdowns.map((_, idx) => {
                                    return (
                                        <Row key={`popDdl-${idx}`}>
                                            <Col lg={8}>
                                                <Form.Select onChange={(e) => {

                                                    let filtered = filterByPopulations? [...filterByPopulations] : [];
                                                    if(filtered[idx]) {
                                                        filtered[idx] = e.target.value;
                                                    }
                                                    else {
                                                        filtered.push(e.target.value);
                                                    }
                                                    setFilterByPopulations(filtered);

                                                }} value={ filterByPopulations && filterByPopulations[idx]? filterByPopulations[idx] : "" } aria-label="Seleccione el tipo de vacuna">
                                                    <option>Seleccione la poblaci&oacute;n</option>
                                                    {
                                                        populationTypes.map((pop, index) => {
                                                            return <option value={pop.populationTypeId} key={`pop-${idx}-${index}`}>{pop.name}</option>
                                                        })
                                                    }
                                                </Form.Select>
                                            </Col>
                                            <Col lg={2}>
                                                <Button onClick={() => {
                                                    let popDdl = [...populationDropdowns];
                                                    let filtered = filterByPopulations? [...filterByPopulations] : [];
                                                    popDdl.splice(idx, 1);
                                                    filtered.splice(idx, 1);
                                                    setPopulationDropdowns(popDdl);
                                                    setFilterByPopulations(filtered);
                                                }} variant="link">Remover</Button>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                            <br />
                            {/* <Row>
                                <Col lg={3}>
                                    <Form.Label>Hora de apertura</Form.Label>
                                </Col>
                                <Col>
                                    <DatePicker
                                        className="form-control"
                                        selected={filterByStartDate}
                                        onChange={(date) => setFilterByStartDate(date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption=""
                                        dateFormat="h:mm aa"
                                        />
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col lg={3}>
                                    <Form.Label>Hora de cierre</Form.Label>
                                </Col>
                                <Col>
                                    <DatePicker
                                        className="form-control"
                                        selected={filterByEndDate}
                                        onChange={(date) => setFilterByEndDate(date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption=""
                                        dateFormat="h:mm aa"
                                        />
                                </Col>
                            </Row>
                            <br /> */}
                            <Row>
                                <Col className="d-grid gap-2">
                                    <Button variant="see-more" disabled={!hasFilters()} type="submit" size="lg">Filtrar</Button>
                                </Col>
                            </Row>
                        </fieldset>
                    </Form>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}